export const downloadFile = (url, name) => {
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = name + ".pdf";
    document.body.appendChild(a);
    a.click();
};